import { DatePipe, NgIf } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import * as Global from '../../../../global';
import { HelpersService } from '../../../../services/helpers.service';
import { NavService } from '../../../../services/nav.service';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ToastService } from '@app/services/toast.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SupportService } from '../support.service';
import { AuthService } from '../../../../services/auth.service';
@Component({
  selector: 'change-password',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    NgxSkeletonLoaderModule,
    DatePipe,
    NgIf,
    MatDatepickerModule,
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
})
export class ChangePasswordComponent {
  @Input() data: any = null;
  Global = Global;
  isLoading: boolean = false;
  notifications: any = [];
  formGroup!: FormGroup;
  hide:boolean[] = [];

  constructor(
    private fb: FormBuilder,
    public toastr: ToastService,
    public navService: NavService,
    public authService: AuthService,
    private supportService: SupportService,
    private helpers: HelpersService
  ) {}
  ngOnChanges() {
    this.formGroup = this.fb.group({
      userName: [this.helpers.userEmail(), Validators.compose([Validators.required])],
      oldPassword: [null, Validators.compose([Validators.required])],
      newPassword: [null, Validators.compose([Validators.required,Validators.minLength(8)])],
      confirmPassword: [null, Validators.compose([Validators.required,this.matchPasswordValidator])],
    },{
      validators: Global.MustMatch('newPassword', 'confirmPassword')
  });
  }
  
  onSubmit(event: any) {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;
      let formData: any = this.formGroup.value;
      this.supportService.changePassword(formData).subscribe({
        next: (res) => {
          this.toastr.success(`Password Reset successfully`);
          this.navService.openSideNav({ toogle: true });
          this.authService.userLogout()
        },
        error: (err) => {
          event.target.classList.remove('btn-loading');
          event.target.disabled = false;
        },
        complete: () => {
          event.target.classList.remove('btn-loading');
          event.target.disabled = false;
        },
      });
    }
  }
  private matchPasswordValidator(control: AbstractControl): ValidationErrors | null {
    const newPassword = control.get('newPassword');
    const confirmPassword = control.get('confirmPassword');

    if (newPassword && confirmPassword) {
      if (newPassword.value !== confirmPassword.value) {
        return { mismatch: true };
      }
    }

    return null;
  }
}
